import React, { useEffect } from "react";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Button, Dropdown, Layout, theme } from "antd";
import AdminSidebar from "./components/adminSidebar";
import { ADMIN, DEALER, SALESMAN } from "../redux/constants/roles";
import { useDispatch, useSelector } from "react-redux";
import AdminRoutes from "../routes/adminRoutes";
import AuthRoutes from "../routes/authRoutes";
import { useLocation } from "wouter";
import { checkSessionTimeout, logout } from "../redux/reducers/authSlice";

const { Header, Sider, Content } = Layout;

const AdminApp = () => {
  const [collapsed, setCollapsed] = React.useState(false);
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const authData = useSelector((state) => state.auth_store);
  const dispatch = useDispatch();
  const [location, setLocation] = useLocation();
  // const authRoutes = [
  //   "/admin/login",
  //   "/admin/forgot-password",
  //   "/admin/reset-password",
  // ];

  React.useEffect(() => {
    if (authData.role === DEALER) {
      setLocation("/");
    }
    if (!authData.is_Login) {
      setLocation("/admin/login");
    } else if (location === "/admin" || location === "/admin/") {
      setLocation("/admin/order-requests");
    }
  }, [authData.is_Login, authData.role, location, setLocation]);
  console.log("authData is -----------", authData);
  const handleLogout = () => {
    dispatch(logout());
    setLocation("/admin/login");
  };

  const menuItems = [
    {
      key: 1,
      label: "Log Out",
      onClick: handleLogout,
    },
  ];
  useEffect(() => {
    dispatch(checkSessionTimeout());
  }, [dispatch]);
  return (
    <Layout className="min-h-screen">
      {authData.is_Login ? (
        <>
          <Sider
            trigger={null}
            collapsible
            collapsed={collapsed}
            theme={"light"}
            width={250}
          >
            <AdminSidebar collapsed={collapsed} role={authData.role} />
          </Sider>
          <Layout>
            <Header
              className="flex justify-between items-center text-lg px-2"
              style={{
                background: colorBgContainer,
              }}
            >
              <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={() => setCollapsed(!collapsed)}
              />

              <Dropdown menu={{ items: menuItems }} trigger={["click"]}>
                <UserOutlined className="border-2 border-black rounded-full p-1" />
              </Dropdown>
            </Header>
            <Content className="bg-white m-4 p-4 rounded-xl">
              <AdminRoutes />
            </Content>
          </Layout>
        </>
      ) : (
        <AuthRoutes />
      )}
    </Layout>
  );
};

export default AdminApp;
